import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function PixelBus() {
  const { data } = useSelector(state => state.store);

  useEffect(() => {
    if (!data?.empresa) return;

    const pixelBusId = data.empresa.pixel_bus_id;

    if (pixelBusId) {
      loadPixelBus(pixelBusId);
    }
  }, [data]);

  const loadPixelBus = (pixelBusId) => {
    // Verifica se já foi carregado
    if (window.fbq) return;

    // Inicializa a fila do fbq antes de carregar o script,
    // conforme padrão oficial da Meta (os comandos são enfileirados
    // e executados assim que fbevents.js terminar de carregar)
    window.dataLayer = window.dataLayer || [];
    const fbq = window.fbq = function() {
      fbq.callMethod
        ? fbq.callMethod.apply(fbq, arguments)
        : fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];

    fbq('init', pixelBusId);
    fbq('track', 'PageView');

    // Insere o script no <head>, conforme recomendação oficial da Meta
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);

    // Noscript fallback
    const existingNoScript = document.querySelector(`noscript[data-pixel="${pixelBusId}"]`);
    if (!existingNoScript) {
      const noscript = document.createElement('noscript');
      noscript.setAttribute('data-pixel', pixelBusId);
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixelBusId}&ev=PageView&noscript=1" alt="" />`;
      if (document.body.firstChild) {
        document.body.insertBefore(noscript, document.body.firstChild);
      } else {
        document.body.appendChild(noscript);
      }
    }

    console.log(`[PixelBus] Carregado com ID: ${pixelBusId}`);
  };

  return null;
}
